<template>
    <div style=" max-width: 100vw; overflow: hidden;">
        <meta http-equiv=”Content-Type” content=”text/html; charset=UTF-8″ />
        <Navbar />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
        <section id="section-presentacion" class="padding-generales seccion">
            <div class="container position-texto">
                <div class="row text-left text-md-start">
                    <div class="col-md-10 animate__animated animate__fadeInLeft parrafos-altura-generales">
                        <h1 class="textos subtitulos-principales2 blanco bold">
                            TRANQUILIDAD Y SEGURIDAD CON SENTIDO HUMANO
                        </h1>
                        <p class="textos subtitulos-intermedios-sec-ajustes blanco regular py-md-5 py-5">
                            {{anoExperiencia}} años brindando servicios legales y asistenciales de alta especialidad a nuestros clientes.
                        </p>
                    </div>
                </div>
            </div>
            <video class="videos-2" loop autoPlay muted>
                <source src="../assets/template/video/video-home.mp4" type="video/webm" playsInline />
                <source src="../assets/template/video/video-home.mp4" type="video/mp4" playsInline />
            </video>
        </section>
        <section id="flechas-generales">
            <div class="flecha-down wow animate__animated animate__fadeInDown animate__infinite	infinite animate__slow">
                <img src="../assets/template/images/flecha-abajo.png" alt="" />
            </div>
        </section>
        <section class="py-4 iconosImg">
            <div class="container">
                <div class="row d-flex justify-content-center py-1 py-md-5">
                    <div class="col-md-10 text-center">
                        <h2 class="textos subtitulos-intermedios2 azul bold">ESTAMOS SIEMPRE CONTIGO</h2>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-2">
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-1.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">ERES LO MÁS IMPORTANTE</h4>
                        <p class="textos parrafos-intermedios negro light">Nuestro <span class="textos parrafos-intermedios azul bold">enfoque en el cliente</span> nos permite aportar valor a Aseguradoras, Brokers y Empresas privadas.</p>
                    </div>
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-2.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">TECNOLOGÍA EFICIENTE</h4>
                        <p class="textos parrafos-intermedios negro light">Nuestras <span class="textos parrafos-intermedios azul bold">Apps y sistemas únicos en el sector</span> están diseñados para facilitar el uso y la experiencia de nuestros servicios.</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-2">
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-3.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">SERVICIO PERSONALIZADO</h4>
                        <p class="textos parrafos-intermedios negro light"><span class="textos parrafos-intermedios azul bold">Adaptamos nuestras soluciones a las necesidades</span> de tu empresa y te asesoramos para encontrar configuración ideal.</p>
                    </div>
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-4.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">ALTA ESPECIALIDAD</h4>
                        <p class="textos parrafos-intermedios negro light">Somos <span class="textos parrafos-intermedios azul bold">profesionales experimentados</span> que se toman muy en serio el ámbito Jurídico para que tú y tus clientes no se preocupen por nada.</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-2">
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-5.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">UNA EXPERIENCIA REAL</h4>
                        <p class="textos parrafos-intermedios negro light">{{anoExperiencia}} años de experiencia, sólida presencia Nacional y una red con más de 500 especialistas <span class="textos parrafos-intermedios azul bold">garantizarán tu tranquilidad.</span></p>
                    </div>
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-6.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">SATISFACCIÓN GARANTIZADA</h4>
                        <p class="textos parrafos-intermedios negro light">Brindamos siempre un <span class="textos parrafos-intermedios azul bold">servicio oportuno y ágil</span> gracias a nuestra tecnología y Centro de Atención Permanente.</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="section-descanso" class="py-5 descansoImg">
            <div class="container py-4">
                <div class="row">
                    <div class="col-md-8">
                        <h3 class="textos subtitulos-intermedios2 blanco bold">CONOCE NUESTROS SERVICIOS</h3>
                        <p class="textos section-historia-secundarios blanco light">9 soluciones asistenciales y jurídicas que blindarán a tu organización y clientes finales.</p>
                        <div class="row  pt-md-2  animate__animated animate__fadeInDown">
                            <div class="col-12 col-md-6 pt-md-5 pt-3 animate__animated animate__pulse animate__infinite	infinite">
                                <router-link class="bg-rojo px-4 py-2 rounded-pill textos parrafos-principales regular blanco mayus" :to="{name: 'Servicios'}">Quiero ver más</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="section-numeralia" class="py-5 numeraliaImg">
            <div class="container">
                <div class="row d-flex justify-content-center py-md-5">
                    <div class="col-6 col-md-5 text-center">
                        <h3 class="textos titulos-secundarios azulFuerte bold"><span class="textos titulos-secundarios amarillo bold">+</span>{{anoExperiencia}}</h3>
                        <p class="textos subtitulos-intermedios-sec azulFuerte ligth">años de experiencia</p>
                    </div>
                    <div class="col-6 col-md-5 text-center">
                        <h3 class="textos titulos-secundarios azulFuerte bold"><span class="textos titulos-secundarios amarillo bold">+</span>200</h3>
                        <p class="textos subtitulos-intermedios-sec azulFuerte ligth">colaboradores</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-md-5">
                    <div class="col-6 col-md-5 text-center">
                        <h3 class="textos titulos-secundarios azulFuerte bold"><span class="textos titulos-secundarios amarillo bold">+</span>300</h3>
                        <p class="textos subtitulos-intermedios-sec azulFuerte ligth">abogados</p>
                    </div>
                    <div class="col-6 col-md-5 text-center">
                        <h3 class="textos titulos-secundarios azulFuerte bold"><span class="textos titulos-secundarios amarillo bold">+</span>30</h3>
                        <p class="textos subtitulos-intermedios-sec azulFuerte ligth">clientes de alto nivel</p>
                    </div>
                </div>
                <div class="row  pt-md-2  animate__animated animate__fadeInDown">
                    <div class="col-12 col-md-12 text-center pt-md-5 pt-3 animate__animated animate__pulse animate__infinite	infinite">
                        <router-link class="bg-rojo px-4 py-2 rounded-pill textos parrafos-principales regular blanco mayus" :to="{name: 'Nosotros'}">Nosotros</router-link>
                    </div>
                </div>
            </div>
        </section>
        <section id="section-mapa" class="py-5">
            <div class="container">
                <div class="row d-flex justify-content-center ">
                    <div class="col-md-10 text-center">
                        <h2 class="textos subtitulos-intermedios2 azul bold py-md-4">SÓLIDA PRESENCIA NACIONAL</h2>
                        <p class="textos parrafos-principales negro light py-md-4">Cubrimos todo el país y contamos con 9 oficinas regionales estratégicamente ubicadas</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center pt-5 py-md-1">
                    <div class="col-md-12 text-center">
                        <img src="../assets/template/images/mapa.png" alt="" class="img-fluid" />
                    </div>
                </div>
            </div>
        </section>
        <div>
            <section>
                <div class="container">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-10 text-center">
                            <h2 class="textos subtitulos-intermedios2 azul bold py-4">ELLOS PONEN SU TRANQUILIDAD EN NUESTRAS MANOS</h2>
                        </div>
                    </div>
                </div>
            </section>

            <section id="section-clientes" class='my-4'>
                <div class="container">

                    <!-- Carousel Start -->
                    <agile :initial-slide="0" :autoplay="true" :centerMode="true" :navButtons="false" :dots="false">
                        <div class="slide">
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/1.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/2.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/3.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/4.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/5.png" class="img-fluid img-fluid2" alt="">
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/6.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/7.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/8.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/9.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/10.png" class="img-fluid img-fluid2" alt="">
                                </div>

                            </div>
                        </div>
                        <div class="slide">
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/11.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/12.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/13.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/14.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/15.png" class="img-fluid img-fluid2" alt="">
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/16.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/17.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/18.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/19.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/20.png" class="img-fluid img-fluid2" alt="">
                                </div>

                            </div>
                        </div>


                        <template slot="prevButton">
                            <i class="fas fa-chevron-left"></i>
                        </template>
                        <template slot="nextButton">
                            <i class="fas fa-chevron-right"></i>
                        </template>
                    </agile>
                    <!-- Carousel End -->
                    <div class="row  pt-md-2  animate__animated animate__fadeInDown">
                        <div class="col-12 col-md-12 text-center pt-md-5 pt-3 animate__animated animate__pulse animate__infinite	infinite">
                            <router-link class="bg-rojo px-4 py-2 rounded-pill textos parrafos-principales regular blanco mayus" :to="{name: 'Clientes'}">ver clientes</router-link>
                        </div>
                    </div>
                </div>

            </section>
            <Footer />
        </div>

    </div>
</template>
<style>
    @import "../assets/template/css/HSectionNum.css";
    @import "../assets/template/css/Home.css";
    @import "../assets/template/css/HomaMedia.css";
    @import "../assets/template/css/textosF.css";
    @import "../assets/template/css/Icons.css";
    @import "../assets/template/css/HSectionFrase.css";
    @import "../assets/template/css/HSectionMap.css";
    @import "../assets/template/css/NavMenu.css";
    @import "../assets/template/css/NavMenuMedia.css";
    @import "../assets/template/css/generals.css";
    @import "../assets/template/css/HSectionClientesMedia.css";

    .descansoImg {
        background-image: url("../assets/template/images/banner.png");
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    
    .numeraliaImg {
        background-image: url("../assets/template/images/fondo-numeralia.png");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .iconosImg {
        background-image: url("../assets/template/images/fondo.png");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .img-fluid2 {
        /*flex: 0 0 33.333333%;
        max-width: 33.333333%;*/
    }

    
    
</style>

<!--<script>

    import VueSlickCarousel from 'vue-slick-carousel'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        name: 'MyComponent',
        components: { VueSlickCarousel },
    }

</script>-->

<script>
    import Navbar from './shared/Navbar/Navbar.vue';
    import Footer from './shared/footer/Footer.vue';

    import { VueAgile } from 'vue-agile';

    export default {
      
        components: {
            Navbar,
            Footer,
            agile: VueAgile,
        },
        data() {
            
            return {
                fechaActual: new Date().getFullYear(),
                anoExperiencia: "",
                activarAlert: false,

            };
        },
        computed: {


        },
        methods: {

        },
        mounted() {
            this.anoExperiencia = Math.abs(this.fechaActual - 1974);
            window.scrollTo({ top: 0, behavior: 'smooth' });

        },
    };
</script>
